import { Box } from 'pcln-design-system'
import React from 'react'

const Gpt = (props) => <Box>{props.render()}</Box>

Gpt.displayName = 'Gpt'

export default Gpt
